import { useEffect, useState } from "react";
import { Icon } from "./Icon";

type Mode = "light" | "dark" | null; // null = follow system

function read(): Mode {
  const v = localStorage.getItem("theme");
  return v === "light" || v === "dark" ? v : null;
}

function apply(mode: Mode) {
  const el = document.documentElement;
  if (mode) el.setAttribute("data-theme", mode);
  else el.removeAttribute("data-theme");
}

export function ThemeToggle() {
  const [mode, setMode] = useState<Mode>(read);

  useEffect(() => {
    apply(mode);
  }, [mode]);

  // Light is the default; dark only when the user has opted in.
  const effectiveDark = mode === "dark";

  const toggle = () => {
    const next: Mode = effectiveDark ? "light" : "dark";
    localStorage.setItem("theme", next);
    setMode(next);
  };

  return (
    <button
      className="icon-btn"
      onClick={toggle}
      aria-label={effectiveDark ? "Switch to light mode" : "Switch to dark mode"}
      title={effectiveDark ? "Light mode" : "Dark mode"}
    >
      <Icon name={effectiveDark ? "sun" : "moon"} size={18} />
    </button>
  );
}
